






import { Component, Vue } from 'vue-property-decorator';
import ReportPowerBiContainer from '../../components/report-powerbi-container/report-powerbi-container.vue';
import { TupleDictionary } from '@/utils/tupleDictionary';
import { ClientEnum } from '@/enums/client.enum';
import { CountryEnum, CountryType } from '@/enums/country.enum';
import { Getter } from 'vuex-class';
import { AUTH_GET_CLIENT, AUTH_GET_COUNTRY } from '@/store/modules/authentication/types';
import { Client } from '@/store/modules/authentication/interfaces';
import { traceLogAccess } from '@/services/trace.log.access.service';
import { ContextEnum } from '@/enums/context.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from './pbi-dict-workspace-id';

@Component({
  name: 'PbiMarketDiagnosisStellantisPage',
  components: { ReportPowerBiContainer }
})
export default class PbiMarketDiagnosisStellantisPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();

  public dictReports = new TupleDictionary<[ClientEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.Fiat, CountryEnum.Brasil], { brand: 'Fiat', workspaceId: this.pbiDictWorkspaceId.dictionary[PbiWorkspacesEnum.Neodash], reportId: '4abc2fd5-609b-4367-8100-35330b7192ff' });
    this.dictReports.set([ClientEnum.Jeep, CountryEnum.Brasil], { brand: 'Jeep', workspaceId: this.pbiDictWorkspaceId.dictionary[PbiWorkspacesEnum.Neodash], reportId: 'b9a4f942-de19-4d87-8b67-d77b22f869dd' });
    this.dictReports.set([ClientEnum.Ram, CountryEnum.Brasil], { brand: 'Ram', workspaceId: this.pbiDictWorkspaceId.dictionary[PbiWorkspacesEnum.Neodash], reportId: 'aa256274-689b-4868-abc0-eb85f0a95ede' });
    this.dictReports.set([ClientEnum.Peugeot, CountryEnum.Brasil], { brand: 'Peugeot', workspaceId: this.pbiDictWorkspaceId.dictionary[PbiWorkspacesEnum.Neodash], reportId: '8197eb21-7d93-4290-b850-08e5436f5978' });
    this.dictReports.set([ClientEnum.Citroen, CountryEnum.Brasil], { brand: 'Citroen', workspaceId: this.pbiDictWorkspaceId.dictionary[PbiWorkspacesEnum.Neodash], reportId: 'bbec6125-3427-43b1-87ed-be99d4b33214' });

    this.crrReport = this.dictReports.get([this.client.id, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Market Diagnosis - Stellantis`);
  }
}
